module.exports = __webpack_public_path__ + "static/media/miranda-1.31eeb8b8.jpg";